const overHeadCostTypeConst = {
  Cost_per_Year: "65dd73b54c4587f420433d5b",
  Cost_per_Hour: "65dd73c74c4587f420433d5d",
};
export default overHeadCostTypeConst;

